import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { message } from "antd";
import * as api from "../../../utils/api";
import { LoadingIndicator } from "../../../components/loading";
import { PageLayout } from "../../../components/page-layout";
import * as S from "./styles";

const DEFAULT_ERROR_MESSAGE =
  "Erro inesperado. Por favor, tente novamente mais tarde.";

export const StoreMenuPage = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [campaigns, setCampaigns] = useState([]);

  const handleGetActiveCampaigns = useCallback(async () => {
    setLoading(true);

    try {
      const { result, error } = await api.post("/get-campaigns");

      if (error) {
        throw new Error(error);
      }

      const activeCampaigns = result.filter((i) => i.is_active);

      setCampaigns(activeCampaigns);
    } catch (err) {
      message.error(err.message || DEFAULT_ERROR_MESSAGE);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    handleGetActiveCampaigns();
  }, [handleGetActiveCampaigns]);

  if (loading) {
    return <LoadingIndicator />;
  }

  return (
    <PageLayout>
      <S.MenuContainer>
        <h1>
          {!campaigns?.length ? "Nenhuma campanha ativa" : "Selecionar campanha"}
        </h1>
        {campaigns.map((i, index) => {
          return (
            <div
              className="menu-item"
              onClick={() => navigate(`/questionario/${i.id}`)}
              key={index}
            >
              <h2>{i.title}</h2>
            </div>
          );
        })}
      </S.MenuContainer>
    </PageLayout>
  );
};
